import {inject, Injectable} from "@angular/core";
import ModalService from "./modal.service";
import {ErrorModalComponent} from "../components/error-modal/error-modal.component";

@Injectable({
  providedIn: 'root',
})
export default class ErrorService {
  private readonly modalService: ModalService = inject(ModalService);

  public show(title: string | null = null, description: string | null = null): void {
    this.modalService.open(ErrorModalComponent,
      {
        title: title ?? 'Oops... er is iets verkeerd gegaan',
        description: description ?? 'Er is een fout opgetreden. Probeer het later opnieuw'
      },
      {
        showBackdrop: true,
        layout: {
          fullScreenOnMobile: true,
        }
      });
  }

  public hide(): void {
    this.modalService.close(ErrorModalComponent);
  }
}
